import React from "react";
import { Plus, Trash2 } from "lucide-react";

const ComponentEditor = ({ 
  title = "Components", 
  components = [], 
  onChange, 
  type = "earning" // earning, deduction, variable
}) => {
  const handleAddComponent = () => {
    const newComponent = {
      name: "",
      amount: "",
      is_taxable: type === "earning",
    };
    onChange([...components, newComponent]);
  };

  const handleRemoveComponent = (index) => {
    const updated = components.filter((_, i) => i !== index);
    onChange(updated);
  };

  const handleUpdateComponent = (index, field, value) => {
    const updated = [...components];
    updated[index] = {
      ...updated[index],
      [field]: value,
    };
    onChange(updated);
  };

  return (
    <div className="space-y-3 font-poppins">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-300">
          {title}
        </h4>
        <button
          type="button"
          onClick={handleAddComponent}
          className="flex items-center gap-1 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors"
        >
          <Plus size={16} />
          Add {type === "earning" ? "Earning" : type === "deduction" ? "Deduction" : "Component"}
        </button>
      </div>

      {components.length > 0 ? (
        <div className="space-y-2">
          {components.map((component, index) => (
            <div
              key={index}
              className="grid grid-cols-12 gap-2 p-3 bg-gray-50 dark:bg-gray-700 rounded-md border border-gray-200 dark:border-gray-600"
            >
              <div className="col-span-12 md:col-span-5">
                <input
                  type="text"
                  value={component.name}
                  onChange={(e) =>
                    handleUpdateComponent(index, "name", e.target.value)
                  }
                  placeholder="Component name"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-white text-sm"
                />
              </div>
              <div className="col-span-8 md:col-span-4">
                <input
                  type="number"
                  value={component.amount}
                  onChange={(e) =>
                    handleUpdateComponent(index, "amount", e.target.value)
                  }
                  placeholder="Amount"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-800 dark:text-white text-sm"
                  step="0.01"
                  min="0"
                />
              </div>
              {type === "earning" && (
                <div className="col-span-2 md:col-span-2 flex items-center">
                  <label className="flex items-center gap-1 text-xs text-gray-600 dark:text-gray-400 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={component.is_taxable || false}
                      onChange={(e) =>
                        handleUpdateComponent(index, "is_taxable", e.target.checked)
                      }
                      className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <span className="hidden md:inline">Taxable</span>
                  </label>
                </div>
              )}
              <div className={`col-span-2 md:col-span-1 flex items-center ${type === "earning" ? "" : "md:col-span-3"}`}>
                <button
                  type="button"
                  onClick={() => handleRemoveComponent(index)}
                  className="p-2 text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors"
                >
                  <Trash2 size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 bg-gray-50 dark:bg-gray-700 rounded-md border border-dashed border-gray-300 dark:border-gray-600">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            No {type}s added. Click "Add" to create one.
          </p>
        </div>
      )}

      {components.length > 0 && (
        <div className="flex justify-end pt-2 border-t border-gray-200 dark:border-gray-700">
          <div className="text-sm font-semibold text-gray-700 dark:text-gray-300">
            Total: ₹
            {components
              .reduce((sum, comp) => sum + (parseFloat(comp.amount) || 0), 0)
              .toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ComponentEditor;

